/**
 * Address Types
 *
 * Types for Melissa address suggestion and validation.
 */

// Melissa suggestion response
export interface MelissaSuggestionResult {
  Address: MelissaAddressData;
}

export interface MelissaAddressData {
  Address: string;
  Address1: string;
  AdministrativeArea: string;
  CountryName: string;
  CountrySubdivisionCode: string;
  DeliveryAddress: string;
  ISO3166_2: string;
  Locality: string;
  PostalCode: string;
  Premise: string;
  SubAdministrativeArea: string;
}

// Melissa validation response
export interface MelissaValidationResult {
  AddressLine1: string;
  AddressLine2: string;
  AddressLine3: string;
  AdministrativeArea: string;
  CountryName: string;
  CountrySubdivisionCode?: string;
  ISO3166_2?: string;
  Locality: string;
  PostalCode: string;
  Results: string;
  SubAdministrativeArea: string;
}

// Melissa result codes
export const MELISSA_RESULT_CODES = {
  GENERAL_ERROR: 'AE01',
  UNKNOWN_STREET: 'AE02',
  NON_DELIVERABLE_ADDRESS: 'AE04',
  MISSING_MINIMUM_ADDRESS: 'AE07',
  LOCALITY_PARTIAL: 'AV12',
  VERIFIED: 'AV',
} as const;

// Parsed address for forms
export interface ParsedAddress {
  streetAddress1: string;
  streetAddress2?: string;
  city: string;
  postalCode: string;
  countryArea?: string;
  country: string;
}

// Address suggestion for dropdown
export interface AddressSuggestion {
  id: string;
  displayText: string;
  address: ParsedAddress;
  raw: MelissaAddressData;
}

// Validation result
export interface AddressValidationError {
  field: string;
  message: string;
  code?: string;
}

export interface AddressValidationResult {
  isValid: boolean;
  resultCodes: string[];
  errors: AddressValidationError[];
  correctedAddress?: ParsedAddress;
}
